import { action, makeAutoObservable, observable } from "mobx"
import { RootStore } from "../index";
import BasketModel from "../../model/BasketModel";
import ClientModel from "../../model/ClientModel";
import DeliveryModel from "../../model/DeliveryModel";
import PaymentModel from "../../model/PaymentModel";
import OrderModel from "../../model/OrderModel";
import { APP_SITE_ID } from "../../const/root";
import ProductNotificationSubscriptionModel from "../../model/ProductNotificationSubscriptionModel";
import { enumOrderStatus } from "../../enum/enumOrderStatus";
import { uuidv4 } from "../../helper/uid";
import FavoriteModel from "../../model/FavoriteModel";
import moment from "moment";


export const APP_DELIVERY_TYPE_AUTODELIVERY = 1;   ////  способ доставки Автодоставка
export const APP_DELIVERY_TYPE_COURIER = 2;        ////  способ доставки Курьерская
export const APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO = 4;        ////  способ доставки Курьерской службой
export const APP_DELIVERY_TYPE_TAKEAWAY = 3;       ////  способ доставки Самовывоз

export const APP_PAYMENT_TYPE_NONCASH = 5;          ////  способ оплаты  Безналичные
export const APP_PAYMENT_TYPE_CASH = 4;             ////  способ оплаты  Наличные
export const APP_PAYMENT_TYPE_WEBPAY = 7;             ////  способ оплаты  WEBPAY

export const APP_ORG_TYPE_FIZLICO = 3;              ////  id для физлица ("fizlico")
export const APP_ORG_TYPE_URLICO = 4;               ////  id для юрлица ("urlico")
export const APP_URLICO_CACHE_BH_POINT_ID = 70295;  ////  торговая точка для datesForUrlicoCacheBH

type ProductSubscriptionState = {
    isSubscribed: boolean;
    loading: boolean;
    error: string | null;
};


export class PageBasketStore {
    private rootStore: RootStore | undefined;

    arBasket = [];
    note = '';
    error = '';
    discount2 = 0
    showBtnSend = true;
    allItemsId = [];
    addCountFavoriteToBasket: number = 1;
    selectedOption = {
        Client: { value: 0, label: '' },
        DeliveryType: { value: 1, label: '' }, /// способ доставки (для юрлица по default Автодоставка id = 1 )
        PaymentType: { value: 0, label: '' },
        Dates: { value: 0, label: '', },
        Points: { value: 0, label: '', amount: 0 },
        Note: { value: '', label: '', amount: 0 },
        MethodPay: { value: APP_PAYMENT_TYPE_NONCASH, label: '' },        /// способ оплаты (для юрлица по default Безналичные id = 5  )
        PaymentTypeId: { value: APP_PAYMENT_TYPE_NONCASH, label: '' },    /// способ оплаты (для юрлица по default Безналичные id = 5  )
        ClientShipDates: { value: "", label: '' },    /// Отображение интервалов дат , если физлицо Наличные и Курьерская
    }
    isModalOpen = false;
    isModalOpen2 = false;
    isClosePaymentDate = false;
    setSelectedOption = {
        Client: null,
        DeliveryType: null,
        PaymentType: null,
        Dates: null,
        ClientShipDates: null,
        Points: null,
        Note: null,
        MethodPay: null,
        PaymentTypeId: 0,
    }
    options = {
        Client: [],
        DeliveryType: [],
        PaymentType: [],
        Dates: [],
        ClientShipDates: [],
        Points: [],
        Note: '',
        MethodPay: '',
        PaymentTypeId: [],
    }
    summAll = 0;
    summNds = 0;
    summBase = 0;
    flagPaymentType = 0;
    orderId = 0
    nanSymbol = false
    name = ""
    phone = ""
    org_type = ""
    org_type_id = 0
    isPopupWebPay = false
    linkWebPay = ""
    textAboutErrorWebPayLink = false
    openConfirm = false
    loginUser = ""
    isPopupWebPayAboutMinSum = false
    scores = 0
    futureScores = 0
    showMessageAboutBlockAction = false
    scoresConst = 0
    arrWithDateAndDeliveryType = []
    arrDeliveryTypeForProductPage = []
    deliveryDays = []
    isBotOrderPopupOpen = false
    botOrderPictures: string[] = []
    botOrderRecognizedText = ''
    outOfStockItems: any[] = []
    isRemovingItems = false
    isBasketUpdating = false
    subscriptionState = new Map<number, ProductSubscriptionState>();
    ownConsumption = false
    resolveGiftsLoading = false
    resolveGiftsResult: any = null

    infoText = "Заказы оплаченные до 12.00 можно забрать в этот же день* с 13.00 до 17.00. Заказы оплаченные после 12.00 будут готовы к выдаче на следующий день* с 13.00 до 17.00 *рабочий день"

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this, {
            subscriptionState: observable,
        });
        this.rootStore = rootStore;
        // @ts-ignore
        this.setSelectedOption = {
            // @ts-ignore
            Client: this.setSelectedOptionClient,
            // @ts-ignore
            DeliveryType: this.setSelectedOptionDeliveryType,
            // @ts-ignore
            PaymentType: this.setSelectedOptionPaymentType,
            // @ts-ignore
            Dates: this.setSelectedOptionDates,
            // @ts-ignore
            ClientShipDates: this.setSelectedOptionClientShipDates,
            // @ts-ignore
            Points: this.setSelectedOptionPoints,
            // @ts-ignore
            Note: this.setSelectedOptionNote,
            // @ts-ignore
            MethodPay: this.setSelectedOptionMethodPay,
        }
    }


    setSelectedOptionClient = (e: any) => {
        this.selectedOption.Client = e;
    }

    setSelectedOptionDeliveryType = (item: any) => {
        if (this.selectedOption.Dates && this.selectedOption.Dates.value && this.selectedOption.Dates.label) {
            this.selectedOption.Dates.value = 0
            this.selectedOption.Dates.label = ""
        }
        this.selectedOption.DeliveryType = { value: item.value, label: item.label };
        let clientId = this.rootStore?.mainStore.getClientId();
        const paymentOptions = this.options.PaymentTypeId as any[];
        const setPaymentCopy = (paymentId: number) => {
            const pay = paymentOptions.find((p: any) => p.value === paymentId);
            this.selectedOption.PaymentTypeId = { value: paymentId, label: pay?.label || '' };
            this.selectedOption.MethodPay = { value: paymentId, label: pay?.label || '' };
        };
        ////// Самовывоз
        if (item.value === APP_DELIVERY_TYPE_TAKEAWAY && this.org_type_id === APP_ORG_TYPE_FIZLICO) {
            setPaymentCopy(APP_PAYMENT_TYPE_WEBPAY)
            DeliveryModel.getDates(0, APP_DELIVERY_TYPE_TAKEAWAY, this.setDates, this.setError);
        } else if (item.value === APP_DELIVERY_TYPE_TAKEAWAY && this.org_type_id !== APP_ORG_TYPE_FIZLICO) {
            this.getDeliveryDates(0, APP_DELIVERY_TYPE_TAKEAWAY);
        }
        ///// Автодоставка
        if (item.value === APP_DELIVERY_TYPE_AUTODELIVERY) {
            DeliveryModel.getPoints(clientId, this.getPoints, this.setError);
        }
        ///// Курьерская Sellwin
        if (item.value === APP_DELIVERY_TYPE_COURIER) {
            setPaymentCopy(APP_PAYMENT_TYPE_CASH)
            this.getDeliveryDates(this.selectedOption.Points.value, APP_DELIVERY_TYPE_COURIER);
        }
        ///// Курьерской службой
        if (item.value === APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO) {
            setPaymentCopy(APP_PAYMENT_TYPE_CASH)
            this.getDeliveryDates(this.selectedOption.Points.value, APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO);
        }
    }

    setSelectedOptionMethodPayType = (item: any) => {
        const paymentOptions = this.options.PaymentTypeId as any[];
        const payOption = paymentOptions.find((p: any) => p.value === item);
        this.selectedOption.PaymentTypeId = {
            value: item,
            label: payOption?.label || '',
        };
        this.selectedOption.MethodPay = {
            value: item,
            label: payOption?.label || '',
        };
        this.flagPaymentType = item
        let paymentId = item
        DeliveryModel.getTypes(paymentId, this.setDeliveryType, this.setError);
        if (item === APP_PAYMENT_TYPE_CASH) {
            this.isClosePaymentDate = true
            this.selectedOption.PaymentType.value = 0
            this.discount2 = 0
            this.selectedOption.DeliveryType = {
                value: APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO,
                label: '',
            }
            this.getDeliveryDates(this.selectedOption.Points.value, APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO);
        } else if (item === APP_PAYMENT_TYPE_NONCASH) {
            this.isClosePaymentDate = false
            let clientId = this.rootStore?.mainStore.getClientId();
            this.selectedOption.DeliveryType = {
                value: APP_DELIVERY_TYPE_AUTODELIVERY,
                label: '',
            }
            DeliveryModel.getPoints(clientId, this.getPoints, this.setError); /// получаем даты доставки Автодоставка
        } else if (item === APP_PAYMENT_TYPE_WEBPAY) {
            this.isClosePaymentDate = true
            this.selectedOption.PaymentType.value = 0
            this.discount2 = 0
            this.selectedOption.DeliveryType = {
                value: APP_DELIVERY_TYPE_TAKEAWAY,
                label: '',
            }
            // Самовывоз — всегда общее расписание (pointId=0), как на бэке для type=3
            DeliveryModel.getDates(0, APP_DELIVERY_TYPE_TAKEAWAY, this.setDates, this.setError);
        } else {
            this.isClosePaymentDate = false
        }
        this.getBasket();
    }

    setSelectedOptionPaymentType = (e: any) => {
        this.discount2 = e.value
        this.selectedOption.PaymentType.value = e.value
        this.getBasket();
    }

    setSelectedOptionDates = (e: any) => {
        this.selectedOption.ClientShipDates.value = ""
        this.selectedOption.Dates = e;
        this.checkDeliveryDateModal();
    }

    setSelectedOptionClientShipDates = (e: any) => {
        this.selectedOption.ClientShipDates = e;
        this.selectedOption.Dates = e;
        this.checkDeliveryDateModal();
    }

    setSelectedOptionPoints = (e: any) => {
        this.selectedOption.Points = e;
        this.selectedOption.Dates = { value: 0, label: 'Выберите дату' };
        this.options.Dates = [];
        this.getDeliveryDates(this.selectedOption.Points.value, this.selectedOption.DeliveryType.value);
        this.getNewDate()
    }

    setSelectedOptionNote = (e: any) => {
        this.selectedOption.Note.value = e.target.value;
    }

    setSelectedOptionMethodPay = (item: any) => {
        this.selectedOption.MethodPay = item;
    }

    @action
    minusCount = (item: any) => {
        if (item.basket.count > 1) {
            item.basket.count--;
            BasketModel.addProduct(item.basket, 0, this.setBasket, this.setError);
        }
    }

    @action
    minusCountFavorite = (item: any) => {
        if (item.count > 1) {
            item.count--;
            BasketModel.addProduct(item, 0, this.setBasket, this.setError);
        }
    }

    @action
    productPlus = (item: any) => {
        if (item.isMultiplicity) {
            item.count += item.multiplicity;
        } else {
            item.count++;
        }
        this.changeProduct(item);
    }

    @action
    productMinus = (item: any) => {
        if (item.isMultiplicity) {
            if (item.count - item.multiplicity < item.multiplicity) {
                item.count = item.multiplicity;
            } else {
                item.count -= item.multiplicity;
            }
        } else {
            item.count--;
        }
        if (!item.count) {
            item.count = 1;
            return;
        }
        this.changeProduct(item);
    }

    @action setMultiplicity = (item: any, isValue: boolean) => {
        item.isMultiplicity = isValue;
        if (isValue) {
            if (item.count < item.multiplicity) {
                item.count = item.multiplicity;
            } else {
                item.count = item.count - (item.count % item.multiplicity);
            }
            this.changeProduct(item);
        }
    }

    @action changeProductInput = (e: { target: { value: string } }, item: any) => {
        let count = parseInt(e.target.value);
        if (item.isMultiplicity) {
            if (count) {
                count = count - (count % item.multiplicity);
                if (!count) {
                    item.count = item.multiplicity;
                } else {
                    item.count = count;
                }
            } else {
                item.count = item.multiplicity;
            }
        } else {
            if (count) {
                item.count = count;
            } else {
                item.count = 1;
            }
        }
        this.changeProduct(item);
    }

    @action changeProductInputCatalogPage = (e: { target: { value: string } }, item: any) => {
        item.basket.count = e.target.value;
        BasketModel.addProduct(item.basket, 0, this.setBasket, this.setError);
    }

    @action changeProductInputFavorite = (e: { target: { value: string } }, item: any) => {
        item.count = e.target.value;
        BasketModel.addProduct(item, 0, this.setBasket, this.setError);
    }

    @action init() {
        if (!this.rootStore?.mainStore.isAuth) {
            return;
        }

        this.isModalOpen = false;
        this.syncContactFromMainStore();

        // На перезагрузке /users/info ещё не пришёл — не инициализируем с пустым org_type (иначе уходит в URLICO)
        if (!this.rootStore.mainStore.org_type) {
            return;
        }

        ClientModel.getClients(this.setClients, this.setError);
        DeliveryModel.getDeliveryDays(4, this.setDeliveryDays, this.setError);
        this.rootStore?.pageCatalogStore.getFaforite(this.rootStore.mainStore.clientId);
        this.org_type = this.rootStore.mainStore.org_type
        this.loginUser = this.rootStore.mainStore.loginUser
        if (this.org_type === "fizlico") {
            this.org_type_id = APP_ORG_TYPE_FIZLICO
        } else {
            this.org_type_id = APP_ORG_TYPE_URLICO
        }
        this.reload();
    }

    @action
    syncContactFromMainStore = () => {
        const mainStore = this.rootStore?.mainStore;
        if (!mainStore) {
            return;
        }
        if (mainStore.fullNameForOrderInfo) {
            this.name = mainStore.fullNameForOrderInfo;
        }
        if (mainStore.phoneeForOrderInfo) {
            this.phone = mainStore.phoneeForOrderInfo;
        }
    }

    /** Вызывается из MainStore после загрузки /users/info (перезагрузка страницы) */
    @action
    onUserInfoLoaded = () => {
        this.syncContactFromMainStore();
        const path = window.location.pathname;
        const onOrderOrBasket = path === '/order' || path === '/basket';
        if (!onOrderOrBasket) {
            return;
        }
        // init ещё не отработал (ждали org_type) или тип клиента сменился
        if (!this.org_type_id || (this.rootStore?.mainStore.org_type && this.org_type !== this.rootStore.mainStore.org_type)) {
            this.init();
        }
    }

    @action initForProductPage() {
        if (this.rootStore?.mainStore.isAuth) {
            ClientModel.getClients(this.setClients, this.setError);
            this.org_type = this.rootStore.mainStore.org_type
            if (this.org_type === "fizlico") {
                this.org_type_id = APP_ORG_TYPE_FIZLICO
            } else {
                this.org_type_id = APP_ORG_TYPE_URLICO
            }
            this.reloadForProductPage();
        }
    }


    @action reload() {
        this.isPopupWebPay = false
        this.linkWebPay = ""
        this.resetPaymentDeliveryPair()
        DeliveryModel.getPaymentClientTypeId(this.org_type_id, this.setPaymentTypeByTypeOrgId, this.setError)
    }

    /** Сброс пары оплата/доставка — иначе при back/forward остаётся старый DeliveryType */
    @action
    resetPaymentDeliveryPair = () => {
        this.options.DeliveryType = []
        this.options.Dates = []
        this.options.ClientShipDates = []
        this.selectedOption.Dates = { value: 0, label: '' }
        this.selectedOption.ClientShipDates = { value: '', label: '' }

        if (this.org_type_id === APP_ORG_TYPE_FIZLICO) {
            this.selectedOption.MethodPay = { value: APP_PAYMENT_TYPE_CASH, label: '' }
            this.selectedOption.PaymentTypeId = { value: APP_PAYMENT_TYPE_CASH, label: '' }
            this.selectedOption.DeliveryType = { value: APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO, label: '' }
            this.isClosePaymentDate = true
            this.flagPaymentType = APP_PAYMENT_TYPE_CASH
        } else {
            this.selectedOption.MethodPay = { value: APP_PAYMENT_TYPE_NONCASH, label: '' }
            this.selectedOption.PaymentTypeId = { value: APP_PAYMENT_TYPE_NONCASH, label: '' }
            this.selectedOption.DeliveryType = { value: APP_DELIVERY_TYPE_AUTODELIVERY, label: '' }
            this.isClosePaymentDate = false
            this.flagPaymentType = APP_PAYMENT_TYPE_NONCASH
        }
    }

    @action
    setPaymentTypeByTypeOrgId = (result: any) => {
        if (result.data.length) {
            const filterResultData = result.data.filter((el => (f: any) => !el.has(f.payment.name) && el.add(f.payment.name))(new Set()));
            result.data = filterResultData
            //фильтрация , что бы наличная оплата была первой
            for (let i = 0; i < result.data.length; i++) {
                if (result.data[i].payment.name === "WEBPAY") {
                    result.data.push(result.data[i])
                    result.data.splice(i, 1);
                }
            }
        }

        this.setData(result, 'PaymentTypeId', 'name');
        /// Получаем способы доставки
        if (this.org_type_id === APP_ORG_TYPE_URLICO) {
            let clientId = this.rootStore?.mainStore.getClientId();
            // Всегда дефолт юрлица: безнал + доставки под безнал (не первый элемент из API)
            // Копия объекта — иначе мутация .value при смене оплаты портит options
            const nonCashPay: any = (this.options.PaymentTypeId as any[]).find(
                (item: any) => item.value === APP_PAYMENT_TYPE_NONCASH
            );
            if (nonCashPay) {
                this.selectedOption.PaymentTypeId = { value: nonCashPay.value, label: nonCashPay.label };
                this.selectedOption.MethodPay = { value: nonCashPay.value, label: nonCashPay.label };
            } else {
                this.selectedOption.PaymentTypeId = { value: APP_PAYMENT_TYPE_NONCASH, label: '' };
                this.selectedOption.MethodPay = { value: APP_PAYMENT_TYPE_NONCASH, label: '' };
            }
            this.flagPaymentType = APP_PAYMENT_TYPE_NONCASH;
            this.isClosePaymentDate = false;
            this.selectedOption.DeliveryType = { value: APP_DELIVERY_TYPE_AUTODELIVERY, label: '' };
            PaymentModel.getTypes(clientId, this.setPaymentType, this.setError);
            DeliveryModel.getTypes(APP_PAYMENT_TYPE_NONCASH, this.setDeliveryType, this.setError);  /// для юрлица способы доставки при Безналичном расчете
            DeliveryModel.getPoints(clientId, this.getPoints, this.setError); /// получаем даты доставки Автодоставка
        } else if (this.org_type_id === APP_ORG_TYPE_FIZLICO) {
            this.flagPaymentType = APP_PAYMENT_TYPE_CASH  /// Отключаем проверку по Срок оплаты
            this.isClosePaymentDate = true /// Скрываем срок оплаты
            let clientId = this.rootStore?.mainStore.getClientId();
            DeliveryModel.getPoints(clientId, this.getPoints, this.setError); /// получаем даты доставки Автодоставка
            PaymentModel.getTypes(clientId, this.setPaymentType, this.setError);
            const cashPay: any = (this.options.PaymentTypeId as any[]).find(
                (item: any) => item.value === APP_PAYMENT_TYPE_CASH
            );
            if (cashPay) {
                this.selectedOption.PaymentTypeId = { value: cashPay.value, label: cashPay.label };
                this.selectedOption.MethodPay = { value: cashPay.value, label: cashPay.label };
            } else {
                this.selectedOption.PaymentTypeId = { value: APP_PAYMENT_TYPE_CASH, label: '' };
                this.selectedOption.MethodPay = { value: APP_PAYMENT_TYPE_CASH, label: '' };
            }
            this.selectedOption.DeliveryType = { value: APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO, label: '' };
            DeliveryModel.getTypes(APP_PAYMENT_TYPE_CASH, this.setDeliveryType, this.setError);/// для физ лица способы доставки при Наличном расчете
            DeliveryModel.getDates(this.selectedOption.Points.value, APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO, this.setDates, this.setError);
        }
        this.getBasket();
    }

    @action reloadForProductPage() {
        DeliveryModel.getTypes(0, this.setDeliveryTypeForProductPage, this.setError); // способы доставки
    }

    @action
    changeName = (value: any) => {
        this.name = value
    }

    @action
    changePhone = (value: any) => {
        this.phone = value
    }

    @action
    changeOwnConsumption = (value: boolean) => {
        this.ownConsumption = value
    }

    setData(result: any, keyData: string, keyName: string, keyField: string = '') {
        // @ts-ignore
        this.options[keyData] = [];
        if (keyData === "PaymentTypeId" && result.data?.length) {
            result.data.map((item: any) => {
                // @ts-ignore
                this.options[keyData].push({
                    // @ts-ignore
                    value: item?.payment.id,
                    // @ts-ignore
                    label: item.payment[keyName],
                });
                return item;
            });
        }
        if (result.data?.length && keyData !== "PaymentTypeId") {
            result.data.map((item: any) => {
                if (keyField.length) {
                    // @ts-ignore
                    this.options[keyData].push({
                        // @ts-ignore
                        value: item?.id,
                        // @ts-ignore
                        label: item[keyName],
                        // @ts-ignore
                        [keyField]: item[keyField]
                    });
                } else {
                    // @ts-ignore
                    this.options[keyData].push({
                        // @ts-ignore
                        value: item?.id,
                        // @ts-ignore
                        label: item[keyName],
                    });
                }
                return item;
            });
            if (keyField.length) {
                for (let i = 0; i < result.data.length; i++) {
                    if (result.data[i].isDefault) {
                        // @ts-ignore
                        this.selectedOption[keyData] = {
                            // @ts-ignore
                            value: result.data[i]?.id,
                            // @ts-ignore
                            label: result.data[i][keyName],
                            // @ts-ignore
                            [keyField]: result.data[i][keyField]
                        }
                    }
                }
                // @ts-ignore
                if (this.selectedOption[keyData].value === 0 && this.selectedOption[keyData].label === "") {
                    // @ts-ignore
                    this.selectedOption[keyData] = {
                        // @ts-ignore
                        value: result.data[0]?.id,
                        // @ts-ignore
                        label: result.data[0][keyName],
                        // @ts-ignore
                        [keyField]: result.data[0][keyField]
                    }
                }
            } else {
                // @ts-ignore
                this.selectedOption[keyData] = {
                    // @ts-ignore
                    value: result.data[0]?.id,
                    // @ts-ignore
                    label: result.data[0][keyName],
                }
            }
        }


        // Курьерская Sellwin (id=2) для юрлица — только среды
        if (this.org_type_id === APP_ORG_TYPE_URLICO
            && this.selectedOption.DeliveryType.value === APP_DELIVERY_TYPE_COURIER
            && keyData === 'Dates') {
            this.options.Dates = this.options.Dates.filter((date: any) => moment(date.value).weekday() === 3);
            if (this.options.Dates.length) {
                this.setSelectedOptionDates(this.options.Dates[0]);
            }
        }
    }

    @action
    setDeliveryType = (result: any) => {
        // «Курьерской службой» (id=4) показываем первой
        if (result?.data?.length) {
            result.data = [...result.data].sort((a: any, b: any) => {
                if (a.id === APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO) return -1;
                if (b.id === APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO) return 1;
                return a.id - b.id;
            });
        }
        this.setData(result, 'DeliveryType', 'name');
        // Выбранная доставка должна быть из текущего списка и соответствовать оплате
        // (иначе после back/forward остаётся старый id, которого уже нет в options)
        this.syncSelectedDeliveryToPayment();
    }

    /** Подбирает DeliveryType под текущий PaymentTypeId из загруженных options */
    @action
    syncSelectedDeliveryToPayment = () => {
        if (!this.options.DeliveryType?.length) {
            return;
        }
        const paymentId = this.selectedOption.PaymentTypeId.value;
        let desiredType = this.selectedOption.DeliveryType.value;

        if (this.org_type_id === APP_ORG_TYPE_FIZLICO) {
            if (paymentId === APP_PAYMENT_TYPE_CASH) {
                desiredType = APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO;
            } else if (paymentId === APP_PAYMENT_TYPE_WEBPAY) {
                desiredType = APP_DELIVERY_TYPE_TAKEAWAY;
            }
        } else if (this.org_type_id === APP_ORG_TYPE_URLICO) {
            if (paymentId === APP_PAYMENT_TYPE_NONCASH) {
                desiredType = APP_DELIVERY_TYPE_AUTODELIVERY;
            } else if (paymentId === APP_PAYMENT_TYPE_CASH) {
                desiredType = APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO;
            }
        }

        const deliveryOptions = this.options.DeliveryType as any[];
        const byId = (id: number) =>
            deliveryOptions.find((item: any) => Number(item.value) === id);

        // Только целевой дефолт сценария — без принудительного fallback на Sellwin (id=2)
        const match = byId(Number(desiredType));
        if (match) {
            this.selectedOption.DeliveryType = { value: match.value, label: match.label };
            return;
        }

        // Нужного id нет в ответе (гонка / список ещё не тот) —
        // не ставим 2 и не берём [0]; оставляем desiredType (напр. 4 с init)
        this.selectedOption.DeliveryType = {
            value: desiredType,
            label: this.selectedOption.DeliveryType.label || '',
        };
    }

    @action
    setDeliveryTypeForProductPage = (result: any) => {
        if (result?.data?.length) {
            result.data = [...result.data].sort((a: any, b: any) => {
                if (a.id === APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO) return -1;
                if (b.id === APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO) return 1;
                return a.id - b.id;
            });
        }
        this.arrDeliveryTypeForProductPage = result.data
        let clientId = this.rootStore?.mainStore.getClientId();
        DeliveryModel.getPoints(clientId, this.getPointsForProductPage, this.setError); // адреса доставок
    }

    @action
    setDeliveryDays = (result: any) => {

        this.deliveryDays = result.data
    }

    shouldUseUrlicoCacheDates = (deliveryType?: number) => {
        const type = deliveryType ?? this.selectedOption.DeliveryType.value;
        // «Курьерской службой» (4) — обычные DPD-даты по адресу клиента, не кэш 70295
        if (type === APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO) {
            return false;
        }
        return this.org_type_id === APP_ORG_TYPE_URLICO
            && this.selectedOption.PaymentTypeId.value === APP_PAYMENT_TYPE_CASH;
    }

    getDeliveryDates = (pointsId?: number, deliveryType?: number) => {
        const type = deliveryType ?? this.selectedOption.DeliveryType.value;
        if (this.shouldUseUrlicoCacheDates(type)) {
            DeliveryModel.getDatesForUrlicoCacheBH(
                APP_URLICO_CACHE_BH_POINT_ID,
                type,
                this.setDatesFromUrlicoCacheBH,
                this.setError
            );
            return;
        }
        // Самовывоз (type=3): у ТТ часто нет своего расписания → всегда общее (pointId=0)
        const points = type === APP_DELIVERY_TYPE_TAKEAWAY
            ? 0
            : (pointsId ?? this.selectedOption.Points.value);
        DeliveryModel.getDates(points, type, this.setDates, this.setError);
    }

    @action
    setDatesFromUrlicoCacheBH = (result: any) => {
        const dates = (Array.isArray(result.data) ? result.data : []).map((item: any) => {
            if (typeof item === 'string') {
                const d = item.split('-');
                return {
                    id: item,
                    name: `${d[2]}.${d[1]}.${d[0]}`,
                    clientShipDates: '',
                };
            }
            return {
                id: item.id,
                name: item.name,
                clientShipDates: item.clientShipDates ?? '',
            };
        });
        this.setData({ data: dates }, 'Dates', 'name');
        this.setData({ data: dates }, 'ClientShipDates', 'clientShipDates');
        this.checkDeliveryDateModal();
    }

    @action
    setDates = (result: any) => {

        // раскоментировать если будут проблемы 

        // // this.selectedOption.DeliveryType.value = 1    Автодоставка 
        // // this.selectedOption.DeliveryType.value = 3    Самовывоз
        // // this.selectedOption.DeliveryType.value = 2    Курьерская
        // // this.selectedOption.DeliveryType.value = 2    Курьерская доставка ДПД для Частных мастеров

        // this.setData(result, 'Dates', 'name');
        // this.setData(result, 'ClientShipDates', 'clientShipDates');

        // код снизу удалить 
        ////////////////////////////////////////////


        const datesArray = this.deliveryDays

        const processDeliveryDates = (result: any, selectedOption: any, org_type: any) => {

            if (datesArray.length) {
                // Фильтрация массива по clientType и deliveryTypeId

                const removeArrayTypeTakeway = datesArray.filter(item =>
                    //@ts-ignore
                    (item.clientType === org_type) &&
                    //@ts-ignore
                    item.deliveryTypeId === selectedOption
                );
              
                const currentDate = moment().format("YYYY-MM-DD"); // Get the current date in the desired format
                removeArrayTypeTakeway.forEach((item: any) => {
                    if (item.date === currentDate && item.comment) {
                        this.infoText = item.comment; // Set infoText to the comment of the matching item
                    }
                });

                result.data = result.data.filter((date: any) => {
                    const dateObj = new Date(date.id);
                    const dateFormatted = dateObj.toISOString().split('T')[0];
                    //@ts-ignore
                    const matchingDate = removeArrayTypeTakeway.find((removeDate) => removeDate.date === dateFormatted);

                    // Условия для времени подачи заявок и получения товаров
                    if (matchingDate) {
                        //@ts-ignore
                        const applicationTime = matchingDate.applicationTime ? parseInt(matchingDate.applicationTime.split(':')[0]) : null;
                        //@ts-ignore
                        const receivingTime = matchingDate.receivingTime ? parseInt(matchingDate.receivingTime.split(':')[0]) : null;

                        if (applicationTime && dateObj.getHours() >= applicationTime) {
                            return false;
                        }

                        if (receivingTime && dateObj.getHours() >= receivingTime) {
                            return false;
                        }
                    }
                    //@ts-ignore
                    return !removeArrayTypeTakeway.some((removeDate) => removeDate.date === dateFormatted);
                });

                // Условия для автодоставки и курьерской доставки юр. лицам (DeliveryType.value = 1 или 2) и org_type !== 'fizlico'
                if ((selectedOption === 1 || selectedOption === 2) && org_type !== 'fizlico') {

                    const removeAutoDeliveryDates = datesArray.filter(item =>
                        //@ts-ignore
                        item.deliveryTypeId === 1 || item.deliveryTypeId === 2
                        //@ts-ignore
                    ).map(item => item.date);

                    result.data = result.data.filter((date: any) => {
                        const dateObj = new Date(date.id);
                        const dateFormatted = dateObj.toISOString().split('T')[0];

                        // Условия для заказов после 16:00 30.12
                        if (dateFormatted === '2024-12-30' && dateObj.getHours() >= 16) {
                            return false;
                        }

                        // Условия для исключения дат доставки
                        return !removeAutoDeliveryDates.includes(dateFormatted);
                    });

                    // Установить ближайшую дату доставки
                    const nextDeliveryDate = new Date('2025-01-08');
                    result.data = result.data.map((date: any) => {
                        const dateObj = new Date(date.id);
                        if (dateObj >= nextDeliveryDate) {
                            return {
                                ...date,
                                nextDeliveryDate: nextDeliveryDate.toISOString().split('T')[0]
                            };
                        }
                        return date;
                    });
                }

                // Условия для курьерской доставки ДПД (DeliveryType.value = 2) для частных лиц (fizlico)
                if (selectedOption === 2 && org_type === 'fizlico') {
                    const removeDPDPrivateDeliveryDates = datesArray.filter(item =>
                        //@ts-ignore
                        item.deliveryTypeId === 2 && item.clientType === 'fizlico'
                        //@ts-ignore
                    ).map(item => item.date);

                    result.data = result.data.filter((date: any) => {
                        const dateObj = new Date(date.id);
                        const dateFormatted = dateObj.toISOString().split('T')[0];

                        // Условия для заказов после 12:00 30.12
                        if (dateFormatted === '2024-12-30' && dateObj.getHours() >= 12) {
                            return false;
                        }

                        // Условия для исключения дат доставки
                        return !removeDPDPrivateDeliveryDates.includes(dateFormatted);
                    });

                    // Установить ближайшие даты доставки ДПД в диапазоне 08.01-11.01
                    const nextDeliveryStartDate = new Date('2025-01-08');
                    const nextDeliveryEndDate = new Date('2025-01-11');
                    result.data = result.data.map((date: any) => {
                        const dateObj = new Date(date.id);
                        if (dateObj >= nextDeliveryStartDate && dateObj <= nextDeliveryEndDate) {
                            return {
                                ...date,
                                nextDeliveryDate: `${nextDeliveryStartDate.toISOString().split('T')[0]}-${nextDeliveryEndDate.toISOString().split('T')[0]}`
                            };
                        }
                        return date;
                    });
                }

                return result;
            } else {
                return result;
            }

        };

        // Пустой ответ API — сбрасываем выбранную дату (иначе react-select показывает старую, напр. 29.09)
        if (!result?.data?.length) {
            this.options.Dates = [];
            this.options.ClientShipDates = [];
            this.selectedOption.Dates = { value: 0, label: '' };
            this.selectedOption.ClientShipDates = { value: '', label: '' };
            return;
        }

        const updatedResult = processDeliveryDates(result, this.selectedOption.DeliveryType.value, this.org_type);

        this.setData(updatedResult, 'Dates', 'name');
        this.setData(updatedResult, 'ClientShipDates', 'clientShipDates');
        this.checkDeliveryDateModal();
    }

    @action
    getPoints = (result: any) => {
        this.setData(result, 'Points', 'name', 'amount');
        this.getDeliveryDates(this.selectedOption.Points.value, this.selectedOption.DeliveryType.value);
    }
    @action
    getPointsForProductPage = (result: any) => {
        // @ts-ignore
        this.org_type = this.rootStore.mainStore.org_type
        this.setData(result, 'Points', 'name', 'amount');
        for (let i = 0; i < this.arrDeliveryTypeForProductPage.length; i++) {
            // @ts-ignore
            const deliveryTypeId = this.arrDeliveryTypeForProductPage[i].id;
            const setDatesForProductPage = (result: any) => {
                // Курьерская Sellwin (id=2) для юрлица — только среды
                if (deliveryTypeId === APP_DELIVERY_TYPE_COURIER && this.org_type !== "fizlico") {
                    let a = result.data ? [...result.data] : []
                    for (let j = 0; j < a.length; j++) {
                        // @ts-ignore
                        if (moment(a[j].id).weekday() !== 3) {
                            a.splice(j, 1)
                            j--;
                        }
                    }
                    // @ts-ignore
                    this.arrDeliveryTypeForProductPage[i]["deliveryTime"] = a
                } else {
                    // @ts-ignore
                    this.arrDeliveryTypeForProductPage[i]["deliveryTime"] = result.data
                }
            }
            if (deliveryTypeId === APP_DELIVERY_TYPE_TAKEAWAY) {
                DeliveryModel.getDates(0, deliveryTypeId, setDatesForProductPage, this.setError);
            } else {
                DeliveryModel.getDates(this.selectedOption.Points.value, deliveryTypeId, setDatesForProductPage, this.setError);
            }
        }
    }
    @action
    getNewDate = () => {
        for (let i = 0; i < this.arrDeliveryTypeForProductPage.length; i++) {
            // @ts-ignore
            const deliveryTypeId = this.arrDeliveryTypeForProductPage[i].id;
            const setDatesForProductPage = (result: any) => {
                // Курьерская Sellwin (id=2) для юрлица — только среды
                if (deliveryTypeId === APP_DELIVERY_TYPE_COURIER && this.org_type !== "fizlico") {
                    let a = result.data ? [...result.data] : []
                    for (let j = 0; j < a.length; j++) {
                        // @ts-ignore
                        if (moment(a[j].id).weekday() !== 3) {
                            a.splice(j, 1)
                            j--;
                        }
                    }
                    // @ts-ignore
                    this.arrDeliveryTypeForProductPage[i]["deliveryTime"] = a
                } else {
                    // @ts-ignore
                    this.arrDeliveryTypeForProductPage[i]["deliveryTime"] = result.data
                }
            }
            if (deliveryTypeId === APP_DELIVERY_TYPE_TAKEAWAY) {
                DeliveryModel.getDates(0, deliveryTypeId, setDatesForProductPage, this.setError);
            } else {
                DeliveryModel.getDates(this.selectedOption.Points.value, deliveryTypeId, setDatesForProductPage, this.setError);
            }
        }
    }

    @action
    setPaymentType = (result: any) => {
        this.setData(result, 'PaymentType', 'name');
        this.getBasket();
    }

    @action
    getBasket() {
        if (window.location.pathname === '/basket') {
            let clientId = this.selectedOption?.Client?.value;
            BasketModel.getBasket(clientId, 0, this.setBasket, this.setError);
        } else {
            let clientId = this.selectedOption?.Client?.value;
            let discount = this.discount2
            BasketModel.getBasket(clientId, discount, this.setBasket, this.setError);
        }
    }

    @action
    getFavorite = () => {
        let clientId = this.rootStore?.mainStore.clientId;
        FavoriteModel.getFavorite(clientId, 0, this.setBasket, this.setError);
    }

    @action
    setClients = (result: any) => {
        this.setData(result, 'Client', 'fullName');
    }

    @action
    addCount = (item: any) => {
        item.basket.count++;
        BasketModel.addProduct(item.basket, 0, this.setBasket, this.setError);
    }

    @action
    addCountFavorite = (item: any) => {
        item.count = this.addCountFavoriteToBasket++
        BasketModel.addProduct(item, 0, this.setBasket, this.setError);
    }

    @action
    addProduct = (item: any) => {
        if (!item.basket.count) {
            item.basket.count = 1;
        }
        BasketModel.addProduct(item.basket, 0, this.setBasket, this.setError);
    }

    @action
    addProductFavorite = (item: any) => {
        if (!item.count) {
            item.count = 1;
        }
        BasketModel.addProduct(item, 0, this.setBasket, this.setError);
    }

    @action
    changeProduct = (item: any) => {
        BasketModel.addProduct(item, 0, this.setBasket, this.setError);
    }

    @action
    productDelete = (item: any) => {
        const clientId = this.rootStore?.mainStore.getClientId();
        // @ts-ignore
        BasketModel.deleteProduct({
            id: item.id,
            clientId: clientId,
            // @ts-ignore
            discount: 0
        }, this.setBasket, this.setError);
    }

    @action
    productDeleteAll = () => {
        const clientId = this.rootStore?.mainStore.getClientId();
        // @ts-ignore
        BasketModel.deleteAllBasket({
            // @ts-ignore
            clientId: clientId,
        }, this.setBasket, this.setError);
    }

    @action
    setBasket = (result: any) => {
        this.scoresConst = 0
        this.summAll = 0;
        this.summNds = 0;
        this.summBase = 0;
        this.scores = 0
        this.showBtnSend = true;
        this.showMessageAboutBlockAction = false
        if (result.data) {
            result.data.map((item: any) => {
                if (item?.product?.price?.final_price) {
                    item.product.price.final_price = parseFloat(item?.product?.price?.final_price).toFixed(2);
                    let vat = parseFloat(item?.product?.propsNoFilter?.vat);
                    let price = parseFloat(item?.product?.price?.final_price);
                    let count = parseFloat(item.count);
                    let Summ = parseFloat((count * price).toFixed(2));
                    let Nds = parseFloat((Summ * vat / 100).toFixed(2));
                    let SummNds = parseFloat((Summ + Nds).toFixed(2));
                    let maxScoresForItem = parseFloat(item?.product?.price?.max_scores);
                    item.product.price['Summ'] = Summ;
                    item.product.price['Nds'] = Nds
                    item.product.price['SummNds'] = SummNds;
                    this.summAll += SummNds;
                    this.summNds += Nds;
                    this.summBase += Summ;

                    item['isMultiplicity'] = !!item.isMultiplicity;
                    item['multiplicity'] = item?.product?.propsNoFilter?.inBox;
                    item.count = parseFloat(item.count);
                    this.scores += count * maxScoresForItem
                    this.scoresConst += count * maxScoresForItem
                    this.scoresConst = parseFloat(this.scoresConst.toFixed(2));

                    if (this.showBtnSend && item.count > item?.product?.stocks[0]?.amount) {
                        this.showBtnSend = false;
                    }

                    if (item?.product?.stocks[0]?.amount === 0) {
                        this.showBtnSend = false;
                    }
                }
                this.allItemsId = item.id
                return item;
            });
            this.summAll = parseFloat(this.summAll.toFixed(2));
            this.summNds = parseFloat(this.summNds.toFixed(2));
            this.summBase = parseFloat(this.summBase.toFixed(2));

            this.scores = parseFloat(this.scores.toFixed(2));
            // @ts-ignore
            if (this.rootStore?.mainStore.scoresAmount < this.scores) {
                this.scores = Number(this.rootStore?.mainStore.scoresAmount)
            }
            let scores = this.scores
            if (scores === 0) {
                this.showMessageAboutBlockAction = true
            }
            let clientId = this.rootStore?.mainStore.getClientId();
            let discount = this.selectedOption?.PaymentType?.value;
            BasketModel.getFutureLoyaltyScores(clientId, discount, scores, this.setLoyaltyScores, this.setError)
        }

        this.arBasket = result.data;
        this.cleanupSubscriptionState();
        this.fetchSubscriptionsForOutOfStockItems();
        // this.showBtnSend = true
        for (let i = 0; i < this.arBasket.length; i++) {
            // @ts-ignore
            if (this.arBasket[i].product.stocks[0].amount === 0) {
                this.showBtnSend = false
            }
            // @ts-ignore
            if (isNaN(this.arBasket[i].count) === true) {
                return this.nanSymbol = true
            } else {
                this.nanSymbol = false
            }
        }
        
        // Сбрасываем флаг обновления корзины после завершения
        this.isBasketUpdating = false;
    }

    getCount = (item: any) => {
        return item?.basket?.count ? item?.basket?.count : 1;
    }

    getCountFavorite = (item: any) => {
        return item?.count ? item?.count : 1;
    }

    @action
    setError = (error: any) => {
        if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            error.response.data.message !== undefined &&
            error.response.data.message === "Сумма заказа для оплаты 0"
        ) {
            this.onTextAboutErrorWebPayLink()
        } else if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            error.response.data.message !== undefined &&
            error.response.data.message === "Сумма заказа изменилась"
        ) {
            window.localStorage.setItem("order", "1")
            document.location.href = '/personal/order-history'
        } else if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            error.response.data.message !== undefined &&
            error.response.data.message === "Сумма заказа для оплаты меньше 5 BYN"
        ) {
            this.isPopupWebPayAboutMinSum = true
            this.arBasket = []
            this.summAll = 0
            this.linkWebPay = ""
        } else if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            error.response.data.message !== undefined &&
            error.response.data.message !== "Сумма заказа для оплаты меньше 5 BYN" &&
            error.response.data.message !== "Сумма заказа изменилась" &&
            error.response.data.message !== "Сумма заказа для оплаты 0"
        ) {
            alert(error.response.data.message)
            window.location.replace('/personal/order-history')
        }

        // this.onTextAboutErrorWebPayLink()

    }

    @action
    saveOrder = () => {
        let ob = this.getObOrder();
        OrderModel.addOrder({ ...ob, status: enumOrderStatus.draft }, this.setOrderSave, this.setError);
    }

    @action
    setOrderSave = () => {
        this.rootStore?.mainStore.setRedirectUrl('/basket-successful');
    }

    @action
    setOrderSend = (result: any) => {
        this.rootStore?.mainStore.getLoyaltyUpdateInfo()
        if (result.data.url && result.data.url.data && this.selectedOption.PaymentTypeId.value === APP_PAYMENT_TYPE_WEBPAY) {
            this.linkWebPay = result.data.url.data.redirectUrl
            // window.location.replace(result.data.url.data.redirectUrl);
        } else if (this.selectedOption.PaymentTypeId.value !== APP_PAYMENT_TYPE_WEBPAY) {
            this.error = '';
            // @ts-ignore
            this.rootStore.appStore.setPopupThankYouSendOrder(true);
        } else if (result.statusCode === 400) {
            console.log("400")
        }
    }

    getOpenModal2() {
        if (!this.selectedOption.Dates.value) {
            return false;
        }
        const diffDays = Math.abs(
            moment(this.selectedOption.Dates.value).startOf('day')
                .diff(moment().startOf('day'), 'days')
        );
        return diffDays > 5;
    }

    checkDeliveryDateModal = () => {
        if (this.getOpenModal2() && this.selectedOption.DeliveryType.value !== APP_DELIVERY_TYPE_TAKEAWAY) {
            this.isModalOpen2 = true;
        }
    }

    @action
    sendOrder = (isModal: boolean) => {
        if (!this.isValid()) {
            return false;
        }
        if (isModal) {
            if (this.getOpenModal2()) {
                this.isModalOpen2 = true;
                return false;
            }
            if (this.selectedOption.Points.amount > this.summAll) {
                this.isModalOpen = true;
                return false;
            }
            if (this.selectedOption.Points.amount > this.summAll) {
                this.isModalOpen = true;
            } else {
                let ob = this.getObOrder();
                OrderModel.addOrder({ ...ob, status: enumOrderStatus.created }, this.setOrderSend, this.setError);
            }
        } else {
            let ob = this.getObOrder();
            OrderModel.addOrder({ ...ob, status: enumOrderStatus.created }, this.setOrderSend, this.setError);
        }
    }

    isValid() {
        let result = true;
        if (!this.selectedOption.Dates.value) {
            alert('Выберите дату доставки!');
        }
        if (!this.selectedOption.Points.value) {
            alert('Выберите торговую точку!');
        }
        if (!this.selectedOption.PaymentType.value) {
            alert('Выберите тип оплаты!');
        }
        return result;
    }


    @action
    onSubmitForm(e: { preventDefault: () => void; }) {
        this.openConfirm = false
        let dateconfirmpersonaldata = this.rootStore?.mainStore.getDateConfirmPersonalData();
        this.textAboutErrorWebPayLink = false
        e.preventDefault();
        let dateNow = moment(Date.now()).format("YYYY-MM-DD")
        let blockDate = '2023-04-17'
        if (!this.phone.length && this.selectedOption.DeliveryType.value === 2) {
            alert("Телефон является обязательным полем для заполнения")
            return
        }
        if (dateNow < blockDate && this.org_type_id === APP_ORG_TYPE_FIZLICO) {
            alert("Извините, но данный функционал временно недоступен")
        } else if (dateconfirmpersonaldata === null) {
            this.rootStore?.mainStore.setOpenConfirmConsent()
            this.openConfirm = true
            return
        } else {
            if (this.validate()) {
                let totalOrderSumm = this.summAll - this.scores
                const isCourierDelivery = this.selectedOption.DeliveryType.value === APP_DELIVERY_TYPE_COURIER
                    || this.selectedOption.DeliveryType.value === APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO;
                if (this.selectedOption.Points.amount > totalOrderSumm && isCourierDelivery) {
                    // @ts-ignore
                    this.rootStore.appStore.setPopupSendOrder(true)
                } else if (this.getOpenModal2()) {
                    this.isModalOpen2 = true;
                    return false;
                } else {
                    let ob = this.getObOrder();
                    if (this.selectedOption.PaymentTypeId.value === APP_PAYMENT_TYPE_WEBPAY) {
                        if (this.summAll < 5) {
                            this.isPopupWebPayAboutMinSum = true
                            return false
                        } else {
                            setTimeout(this.onRemoveLink, 2000000);
                            // setTimeout(this.onTextAboutErrorWebPayLink, 10000);
                            this.isPopupWebPay = true
                            OrderModel.addOrder({
                                ...ob,
                                status: enumOrderStatus.created
                            }, this.setOrderSend, this.setError);
                        }
                    } else {
                        OrderModel.addOrder({ ...ob, status: enumOrderStatus.created }, this.setOrderSend, this.setError);
                    }
                }
            }
        }
        return false;
    }

    @action
    validate() {
        let result = true;

        const paymentOptions = (this.options.PaymentTypeId || []) as any[];
        const deliveryOptions = (this.options.DeliveryType || []) as any[];
        const paymentId = Number(this.selectedOption.PaymentTypeId?.value);
        const deliveryId = Number(this.selectedOption.DeliveryType?.value);

        if (!paymentOptions.length || !paymentId) {
            this.error = 'Способ оплаты не загружен или не выбран';
            alert(this.error);
            return false;
        }
        if (!paymentOptions.some((item: any) => Number(item.value) === paymentId)) {
            this.error = 'Выберите способ оплаты';
            alert(this.error);
            return false;
        }

        if (!deliveryOptions.length || !deliveryId) {
            this.error = 'Способ доставки не загружен или не выбран';
            alert(this.error);
            return false;
        }
        if (!deliveryOptions.some((item: any) => Number(item.value) === deliveryId)) {
            this.error = 'Выберите способ доставки';
            alert(this.error);
            return false;
        }

        for (let code in this.selectedOption) {
            // @ts-ignore
            let item = this.selectedOption[code];
            // @ts-ignore
            if (code === 'Client' || code === 'DeliveryType' || code === 'Points') {
                if (item.value > 0) {

                } else {
                    this.error = 'Заполните обязательные поля';
                    result = false;
                }
            }
            if (code === 'Dates' && item.value === '') {
                this.error = 'Заполните обязательные поле Дата доставки';
                result = false;
            }
            if (code === 'PaymentTypeId' && item.value === 0) {
                this.error = 'Заполните обязательные поле Способ оплаты';
                result = false;
            }
        }
        return result;
    }

    getObOrder = () => {
        const deliveryTypeId = this.selectedOption.DeliveryType.value;
        const isDpdCourier = deliveryTypeId === APP_DELIVERY_TYPE_COURIER
            || deliveryTypeId === APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO;

        if (!isDpdCourier) {
            this.selectedOption.ClientShipDates.value = ""
        }
        // Интервалы DPD нужны и для юрлица при «Курьерской службой»
        if (this.org_type_id !== APP_ORG_TYPE_FIZLICO
            && deliveryTypeId !== APP_DELIVERY_TYPE_COURIER_DLY_FIZLICO) {
            this.selectedOption.ClientShipDates.value = ""
        }
        return {
            blockReason: '',
            clientId: this.selectedOption.Client.value,
            deliveryTimeFrom: '08:00:00',
            deliveryTimeTo: '16:00:00',
            deliveryTypeId: deliveryTypeId,
            ex_id: uuidv4(),
            isProcessed: false,
            note: this.selectedOption.Note.value,
            notJoin: false,
            orderSum: this.summAll,
            scaleDiscountByPaymentDateId: this.selectedOption.PaymentType.value,
            shipDate: this.selectedOption.Dates.value,
            siteId: APP_SITE_ID,
            status: enumOrderStatus.created,
            tradePointId: this.selectedOption.Points.value,
            userId: this.rootStore?.mainStore.id,
            formOfPayment: this.selectedOption.MethodPay.value,
            paymentType: this.selectedOption.PaymentTypeId.value,
            contact: this.name,
            contactPhone: this.phone,
            clientShipDates: this.selectedOption.ClientShipDates.label,
            scoresDebt: this.scores,
            bonusAmount: this.scores,
            ownConsumption: this.ownConsumption
        }
    }

    @action
    onCloseModal = () => {
        this.isModalOpen = false;
    }

    @action
    onCloseModal2 = () => {
        this.isModalOpen2 = false;
    }

    @action
    onCloseModalWebPay = () => {
        window.localStorage.setItem("order", "1")
        this.arBasket = []
        this.summAll = 0
        this.isPopupWebPay = false;
        this.textAboutErrorWebPayLink = false
    }

    @action
    onRemoveLink = () => {
        this.linkWebPay = "";
        this.isPopupWebPay = false;
    }

    @action
    onTextAboutErrorWebPayLink = () => {
        this.textAboutErrorWebPayLink = true
    }

    @action
    onCloseModalWebPayAboutMinSum = () => {
        this.isPopupWebPayAboutMinSum = false
    }

    @action
    setResolveGiftsResult = (result: any) => {
        this.resolveGiftsLoading = false;
        this.resolveGiftsResult = result;
    }

    @action
    clearResolveGiftsResult = () => {
        this.resolveGiftsResult = null;
    }

    @action
    checkGifts = () => {
        const clientId = this.rootStore?.mainStore.getClientId();
        const scaleDiscountByPaymentDateId = this.selectedOption?.PaymentType?.value;
        if (clientId == null || scaleDiscountByPaymentDateId == null) {
            this.setError({ message: 'Выберите срок оплаты' });
            return;
        }
        this.resolveGiftsLoading = true;
        this.resolveGiftsResult = null;
        OrderModel.resolveGifts(
            { clientId: Number(clientId), scaleDiscountByPaymentDateId: Number(scaleDiscountByPaymentDateId) },
            this.setResolveGiftsResult,
            (err: any) => {
                this.resolveGiftsLoading = false;
                this.resolveGiftsResult = null;
                this.setError(err);
            }
        );
    }

    @action
    getFaforiteAndBasketCountForIconOnTheTopPage = () => {
        if (this.rootStore?.mainStore.isAuth) {
            let item = this.rootStore?.mainStore.clientId
            this.rootStore?.pageCatalogStore.getFaforite(item)
            BasketModel.getBasket(item, 0, this.setBasket, this.setError);
        }
    }

    @action
    productMinusScores = (minus: number) => {
        if (this.showMessageAboutBlockAction) {
            alert("Данный товар не учавствует в программе лояльности")
        } else {
            let newValue = this.scores
            if (newValue >= 0.1) {
                this.scores = newValue - minus
                this.scores = parseFloat(this.scores.toFixed(2));
                let clientId = this.rootStore?.mainStore.getClientId();
                let discount = this.selectedOption?.PaymentType?.value;
                let scores = this.scores
                BasketModel.getFutureLoyaltyScores(clientId, discount, scores, this.setLoyaltyScores, this.setError)
            } else if (newValue < 0.1 && newValue > 0) {
                this.scores = newValue - 0.01
                this.scores = parseFloat(this.scores.toFixed(2));
                let clientId = this.rootStore?.mainStore.getClientId();
                let discount = this.selectedOption?.PaymentType?.value;
                let scores = this.scores
                BasketModel.getFutureLoyaltyScores(clientId, discount, scores, this.setLoyaltyScores, this.setError)
            }
        }
    }

    @action
    setLoyaltyScores = (result: any) => {
        if (result && result.data && result.data[0]) {
            this.futureScores = result.data[0].scores
        }
    }

    @action changeScoreInput = (e: { target: { value: string } }) => {
        let scoresAmount = this.rootStore?.mainStore.scoresAmount
        if (this.showMessageAboutBlockAction) {
            alert("В корзине отсутствуют товары из каталога бонусных товаров")
        } else {
            let value = e.target.value
            if (Number(value) > Number(scoresAmount)) {
                return alert(`Максимальное количество бонусов для Вашей корзины ${scoresAmount}`)
            }
            if (Number(value) > this.scoresConst) {
                return alert(`Максимальное количество бонусов для Вашей корзины ${this.scoresConst}`)
            }
            if (this.rootStore?.mainStore.scoresAmount && Number(value) <= this.rootStore?.mainStore.scoresAmount) {
                this.scores = Number(value)
            } else {
                alert("столько баллов у Вас нет")
            }
        }
    }

    @action
    productPlusScores = (plus: number) => {
        let newValue = this.scores
        let plusValue = 0
        let check = this.scoresConst - newValue
        if (this.showMessageAboutBlockAction) {
            alert("В корзине отсутствуют товары из каталога бонусных товаров")
        } else {
            if (newValue < Number(this.rootStore?.mainStore.scoresAmount) && check > 0.1) {
                plusValue = plus
            } else {
                plusValue = 0.01
            }
            if (newValue + plusValue > this.scoresConst) {
                return alert(`Максимальное количество бонусов для Вашей корзины ${this.scoresConst}`)
            }
            // @ts-ignore
            if (newValue < Number(this.rootStore?.mainStore.scoresAmount)) {
                this.scores = newValue + plusValue
                this.scores = parseFloat(this.scores.toFixed(2));
                let clientId = this.rootStore?.mainStore.getClientId();
                let discount = this.selectedOption?.PaymentType?.value;
                let scores = this.scores
                BasketModel.getFutureLoyaltyScores(clientId, discount, scores, this.setLoyaltyScores, this.setError)
            }
        }
    }

    @action
    setBotOrderPopup = (isOpen: boolean, pictures: string[], recognizedText: string) => {
        this.isBotOrderPopupOpen = isOpen;
        this.botOrderPictures = pictures;
        this.botOrderRecognizedText = recognizedText;
    }

    getProductSubscriptionState = (productId: number): ProductSubscriptionState => {
        console.log('getProductSubscriptionState', productId);
        if (!productId) {
            return { isSubscribed: false, loading: false, error: null };
        }
        return this.subscriptionState.get(productId) ?? { isSubscribed: false, loading: false, error: null };
    }

    setProductSubscriptionState = (productId: number, partial: Partial<ProductSubscriptionState>) => {
        if (!productId) {
            return;
        }
        const previous = this.subscriptionState.get(productId) ?? { isSubscribed: false, loading: false, error: null };
        const nextState: ProductSubscriptionState = {
            ...previous,
            ...partial,
        };
        this.subscriptionState.set(productId, nextState);
    }

    getSubscriptionPayload = (productId: number) => {
        const userId = Number(this.rootStore?.mainStore?.id);
        const clientId = Number(this.rootStore?.mainStore?.getClientId());

        if (!productId || !userId || !clientId) {
            return null;
        }

        return {
            productId,
            userId,
            clientId,
            siteId: APP_SITE_ID
        };
    }

    fetchSubscriptionForProduct = (productId: number) => {
        const payload = this.getSubscriptionPayload(productId);
        if (!payload) {
            return;
        }

        this.setProductSubscriptionState(productId, { loading: true, error: null });
        ProductNotificationSubscriptionModel.findOne(
            payload,
            (result: any) => this.onFetchSubscriptionSuccess(productId, result),
            (error: any) => this.onFetchSubscriptionError(productId, error)
        );
    }

    onFetchSubscriptionSuccess = (productId: number, result: any) => {
        const data = result?.data;
        const isActive = data?.active === true;
        this.setProductSubscriptionState(productId, {
            isSubscribed: isActive,
            loading: false,
            error: null,
        });
    }

    onFetchSubscriptionError = (productId: number, error: any) => {
        let errorMessage: string | null = null;
        if (error?.response?.status !== 404 && error?.response?.status !== 400) {
            console.log('Ошибка при получении подписки на товар:', error);
            errorMessage = 'Не удалось получить статус подписки';
        }
        this.setProductSubscriptionState(productId, {
            isSubscribed: false,
            loading: false,
            error: errorMessage,
        });
    }

    subscribeToRestockNotification = (productId: number) => {
        const payload = this.getSubscriptionPayload(productId);
        if (!payload) {
            return;
        }

        this.setProductSubscriptionState(productId, { loading: true, error: null });
        ProductNotificationSubscriptionModel.subscribe(
            payload,
            () => this.onSubscribeSuccess(productId),
            (error: any) => this.onSubscribeError(productId, error)
        );
    }

    onSubscribeSuccess = (productId: number) => {
        this.setProductSubscriptionState(productId, {
            isSubscribed: true,
            loading: false,
            error: null,
        });
    }

    onSubscribeError = (productId: number, error: any) => {
        console.log('Ошибка при подписке на уведомления о товаре:', error);
        this.setProductSubscriptionState(productId, {
            loading: false,
            error: 'Не удалось оформить подписку',
        });
    }

    unsubscribeFromRestockNotification = (productId: number) => {
        const payload = this.getSubscriptionPayload(productId);
        if (!payload) {
            return;
        }
        console.log('unsubscribeFromRestockNotification', payload);
        this.setProductSubscriptionState(productId, { loading: true, error: null });
        ProductNotificationSubscriptionModel.unsubscribe(
            payload,
            () => this.onUnsubscribeSuccess(productId),
            (error: any) => this.onUnsubscribeError(productId, error)
        );
    }

    onUnsubscribeSuccess = (productId: number) => {
        this.setProductSubscriptionState(productId, {
            isSubscribed: false,
            loading: false,
            error: null,
        });
    }

    onUnsubscribeError = (productId: number, error: any) => {
        console.log('Ошибка при отписке от уведомлений о товаре:', error);
        this.setProductSubscriptionState(productId, {
            loading: false,
            error: 'Не удалось отменить подписку',
        });
    }

    cleanupSubscriptionState = () => {
        const currentIds = new Set<number>();
        if (Array.isArray(this.arBasket)) {
            this.arBasket.forEach((item: any) => {
                const productId = Number(item?.product?.id);
                if (productId) {
                    currentIds.add(productId);
                }
            });
        }

        Array.from(this.subscriptionState.keys()).forEach((productId) => {
            if (!currentIds.has(productId)) {
                this.subscriptionState.delete(productId);
            }
        });
    }

    fetchSubscriptionsForOutOfStockItems = () => {
        if (!Array.isArray(this.arBasket)) {
            return;
        }

        if (!this.rootStore?.mainStore?.isAuth) {
            return;
        }

        this.arBasket.forEach((item: any) => {
            const productId = Number(item?.product?.id);
            if (!productId) {
                return;
            }

            const rawStockAmount = Array.isArray(item?.product?.stocks) && item?.product?.stocks.length > 0
                ? Number(item?.product?.stocks[0]?.amount)
                : 0;
            const stockAmount = Number.isFinite(rawStockAmount) ? rawStockAmount : 0;
            const finalPrice = Number(item?.product?.price?.final_price);
            const hasPrice = !isNaN(finalPrice) && finalPrice > 0;
            const isOutOfStock = stockAmount <= 0 || !hasPrice;

            if (isOutOfStock) {
                const currentState = this.subscriptionState.get(productId);
                if (!currentState || currentState.error) {
                    this.fetchSubscriptionForProduct(productId);
                }
            }
        });
    }

    getOutOfStockItems = () => {
        return this.arBasket.filter((item: any) => {
            return item.product.stocks[0].amount < item.count || item.product.stocks[0].amount === 0;
        });
    }

    @action
    removeOutOfStockItems = async () => {
        const clientId = this.rootStore?.mainStore.getClientId();
        const itemsToRemove = this.getOutOfStockItems();
        
        // Создаем массив промисов для удаления товаров
        const deletePromises = itemsToRemove.map((item: any) => {
            return new Promise((resolve, reject) => {
                BasketModel.deleteProduct({
                    id: item.id,
                    clientId: clientId,
                    discount: 0
                }, 
                (result: any) => {
                    console.log('Товар удален:', item.product.name);
                    resolve(result);
                }, 
                (error: any) => {
                    console.error('Ошибка удаления товара:', error);
                    reject(error);
                });
            });
        });
        
        try {
            // Ждем удаления всех товаров
            await Promise.all(deletePromises);
            console.log('Все отсутствующие товары удалены');
            this.outOfStockItems = [];
        } catch (error) {
            console.error('Ошибка при удалении товаров:', error);
        }
    }

    @action
    proceedWithOrderRemovingOutOfStock = async () => {
        const startTime = Date.now();
        const minimumDisplayTime = 1500; // Минимальное время отображения индикатора загрузки (1.5 секунды)
        
        try {
            this.isRemovingItems = true;
            console.log('Начинаем удаление отсутствующих товаров...');
            
            // Удаляем отсутствующие товары и ждем завершения
            await this.removeOutOfStockItems();
            
            console.log('Удаление завершено, обновляем корзину...');
            
            // Устанавливаем флаг обновления корзины
            this.isBasketUpdating = true;
            
            // Запускаем обновление корзины
            this.getBasket();
            
            // Ждем, пока корзина обновится (проверяем флаг каждые 100ms)
            while (this.isBasketUpdating) {
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            
            console.log('Корзина обновлена, переходим к оформлению заказа');
            
            // Обеспечиваем минимальное время отображения индикатора загрузки
            const elapsedTime = Date.now() - startTime;
            const remainingTime = minimumDisplayTime - elapsedTime;
            
            if (remainingTime > 0) {
                console.log(`Ожидание минимального времени отображения: ${remainingTime}ms`);
                await new Promise(resolve => setTimeout(resolve, remainingTime));
            }
            
            // Закрываем попап
            this.rootStore?.appStore.setPopupExistCount(false);
            
            // Перенаправляем на оформление заказа
            window.location.href = '/order';
            
        } catch (error) {
            console.error('Ошибка при обработке заказа:', error);
            alert('Произошла ошибка при удалении товаров. Попробуйте еще раз.');
        } finally {
            this.isRemovingItems = false;
        }
    }

}
